.search-table {
  &.quotes {
    width: -webkit-fill-available;
    overflow-y: hidden;
    border-collapse: collapse;

    .search-table-header {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      height: 37px;
      background-color: #ffffff;
      border: 1px solid #d8d6d6;
      text-align: left;
      cursor: pointer;
      padding: 0px;
      &-margin-left {
        margin-left: 10px;
      }
    }

    .search-table-header-item {
      margin-left: 10px;
    }

    .search-table-column-item {
      --se-table-item-padding: 0px 0px;
      background-color: #ffffff !important;
      height: 47px;
      align-items: center;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      border-bottom: 1px solid #e7e6e6;
      word-wrap: break-word;
      margin-left: 10px;
    }

    .search-table-link-text {
      color: #0087cd;
      text-decoration: none;
      display: table-cell;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .search-table-column-item-content {
      margin-top: 8px;
      margin-bottom: 4px;
      margin-left: 10px;
    }

    .search-table-row-group {
      height: 54px;
    }

    .search-table-header-group {
      height: 37px;
      padding: 0px;
      display: contents;
    }

    .result-status-text {
      font-style: normal !important;
      font-weight: 400 !important;
      font-size: 16px !important;
      line-height: 22px !important;
      color: #333333 !important;
    }

    .search-table-action-icon {
      color: #0087cd !important;
      display: inline-flex;
      margin-top: 5px;
      margin-right: 8px;
    }

    .search-table-link-file {
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .search-table-sorting-arrow {
      height: 16px;
      position: inherit;
      justify-items: end;
      float: right;
      display: flex;
      padding-top: 5px;
      margin-right: 5px;
    }

    .search-table-pdf-buttton {
      border: none;
      background: none;
      margin-left: 15px;
    }

    .highlight {
      font-size: inherit;
      font-weight: 700;
      line-height: 22px;
    }

    .search-table-sorting-button {
      border: none;
      background: none;
      display: contents;
    }

    .result-status-text {
      font-size: 14px !important;
    }

    .search-tab-loading__container {
      padding-top: 70px;
      width: 100%;
      height: 150px;
      display: flex;
      justify-content: center;
      background: white;
    }

    .search-tab-loading-icon {
      height: 66px;
      width: 66px;
      fill: #0a9a25;
      -webkit-animation: clockwiseSpin 1.5s infinite linear;
      animation: clockwiseSpin 1.5s infinite linear;
      @keyframes clockwiseSpin {
        0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
  }

  &.basic {
    .search-table-header {
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      height: 48px;
      background-color: #ffffff;
      border: none;
      border-bottom: 1px solid #9fa0a4;
      text-align: left;
      cursor: pointer;
    }

    .search-table-header-item {
      margin-left: 10px;
    }

    .search-table-column-item {
      --se-table-item-padding: 0px 0px;
      background-color: #ffffff !important;
      height: 47px;
      align-items: center;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      border-bottom: 1px solid #e7e6e6;
      word-wrap: break-word;
    }

    .search-table-column-item-content {
      margin-top: 8px;
      margin-bottom: 4px;
      display: table-cell;
    }

    .search-table-row-group {
      height: 54px;
    }

    .search-table-header-group {
      border-top: none;
      border-right: none;
      border-left: none;
    }

    .search-table-action-icon {
      color: #0087cd !important;
      display: inline-flex;
      margin-top: 5px;
      &:hover {
        text-decoration: none !important;
        cursor: pointer;
      }
    }

    .search-table-link-text {
      color: #0087cd;
      text-decoration: none;
      display: table-cell;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .search-table-pdf-buttton {
      border: none;
      background: none;
      margin-left: 15px;
    }

    .highlight {
      font-size: inherit;
      font-weight: 700;
      line-height: 22px;
    }

    .search-table-sorting-button {
      border: none;
      background: none;
      display: contents;
    }

    .tabular-sorting-arrows {
      display: inline-grid;
      position: absolute;
      height: 32px;
      margin-left: 8px;
    }

    .search-table-sorting-arrow {
      height: 16px;
    }

    .result-status-text {
      font-size: 14px !important;
    }
    .search-tab-loading__container {
      padding-top: 70px;
      width: 100%;
      height: 150px;
      display: flex;
      justify-content: center;
      background: white;
    }

    .search-tab-loading-icon {
      height: 40px;
      width: 40px;
      fill: #0a9a25;
      -webkit-animation: clockwiseSpin 1.5s infinite linear;
      animation: clockwiseSpin 1.5s infinite linear;
      @keyframes clockwiseSpin {
        0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
  }

  &.cybersecurity {
    .search {
      width: 100%;
      width: -webkit-fill-available;
    }

    .search-table-header {
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      height: 48px;
      background-color: #ffffff;
      border: none;
      text-align: left;

      cursor: pointer;
    }

    .search-table-header-item {
      margin-left: 25px;
    }

    .search-table-column-item {
      --se-table-item-padding: 0px 0px;
      background-color: #ffffff !important;
      height: 47px;
      align-items: center;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      border-bottom: 1px solid #e7e6e6;
      word-break: break-word;
    }

    .search-table-column-item-content {
      margin-top: 8px;
      margin-bottom: 4px;
      padding-left: 25px;
      display: table-cell;
      word-break: break-word;
    }

    .search-table-row-group {
      height: 54px;
    }

    .search-table-row-group:first-child {
      margin-top: 20px;
    }

    .search-table-header-group {
      border-top: none;
      border-right: none;
      border-left: none;
      position: sticky;
      top: 110px;
      box-shadow: 0 5px 5px rgb(51 51 51 / 15%);
      z-index: 9;
      margin-bottom: 20px;
    }

    .search-table-action-icon {
      color: #0087cd !important;
      display: inline-flex;
      margin-top: 5px;

      &:hover {
        text-decoration: none !important;
        cursor: pointer;
      }
    }

    .search-table-link-text {
      color: #0087cd;
      text-decoration: none;
      display: inline-flex;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .search-table-pdf-buttton {
      border: none;
      background: none;
      margin-left: 15px;
    }

    .highlight {
      font-weight: 700;
      line-height: 22px;
    }

    .search-table-sorting-button {
      border: none;
      background: none;
      display: contents;
    }

    .tabular-sorting-arrows {
      display: inline-grid;
      position: absolute;
      height: 32px;
      margin-left: 8px;
    }

    .search-table-sorting-arrow {
      height: 16px;
    }

    .result-status-text {
      font-size: 14px !important;
    }

    .button-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .button-wrapper a {
      flex-basis: 100%;
    }

    .button-wrapper button {
      position: relative;
      padding-left: 1.5em;
    }

    .button-wrapper svg {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }

    .search-tab-loading__container {
      padding-top: 70px;
      width: 100%;
      height: 150px;
      display: flex;
      justify-content: center;
      background: white;
    }

    .search-tab-loading-icon {
      height: 40px;
      width: 40px;
      fill: #0a9a25;
      -webkit-animation: clockwiseSpin 1.5s infinite linear;
      animation: clockwiseSpin 1.5s infinite linear;
      @keyframes clockwiseSpin {
        0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
  }
}
